// extracted by mini-css-extract-plugin
module.exports = {"about_location":"Location_about_location__BvQDK"};